import React from "react";
import UserVerificationList from "./user-verification-list";

export default function Index() {
  return (
    <React.Fragment>
      <UserVerificationList />
    </React.Fragment>
  );
}
